import { useState } from 'react';

export type GuestErrorMessageResponse = {
  errorMessages: string[];
  lastErrorMessage: string[];
  addErrorMessage: (errMsg: string) => void;
  clearMessages: () => void;
};

const useGuestBoxErrorMessage = (): GuestErrorMessageResponse => {
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const addErrorMessage = (errorMsg: string) => {
    setErrorMessages([
      ...errorMessages.filter((errorMessage) => errorMessage !== errorMsg),
      errorMsg,
    ]);
  };

  const clearMessages = () => {
    setErrorMessages([]);
  };

  return {
    errorMessages,
    lastErrorMessage: errorMessages.length
      ? [errorMessages?.[errorMessages.length - 1]]
      : [],
    addErrorMessage,
    clearMessages,
  };
};

export default useGuestBoxErrorMessage;
